<template>
  <!--
    This is a mail synchronization template
    used to synchronize the users
    Currently used in two routes
    1. configuration/mail-sync/p1
    2. platfrom-admin/mailsync/p1
        -->
  <div>
    <x-org-heading
      v-if="pageType !== $enums.mailSyncPageType.systemAdmin"
      heading="Mail Synchronisation"
    ></x-org-heading>
    <h2 v-else>Mail Synchronisation</h2>

    <x-tabs
      :key="currentOrgId"
      @getSelected="getSelectedTab"
      :tabs="mailSyncFilters"
      class="d-flex flex-row my-4"
    />
    <x-dialog
      width="50%"
      @toggleModal="closeDialog"
      :dialogTitle="dialogProps.dialogTitle"
      :dialogText="dialogProps.dialogText"
      :dialogState="dialogProps.dialogState"
      :confirmDialog="dialogProps.showConfirm"
      :actions="{
        show: true,
        secondaryButtonFunction: closeDialog,
        primaryButtonFunction: dialogAction,
        primaryButtonShow: true,
        secondaryButtonText: 'Cancel',
        primaryButtonText: primaryButtonText,
      }"
    >
      <template slot="dialog_data">
        <v-row
          align="center"
          justify="start"
          class="px-8"
          v-if="dialogProps.modalType === 'SYNC_CONFIRM'"
        >
          <v-col sm="9">
            <v-row no-gutters
              ><span class="mr-4 mt-0 formInputLabel">Select All Users</span>
              <ToggleButtonConfigurable
                id="mailSync"
                :toggleState="mailSyncUserOrg"
                @toggleValue="toggleMailSyncUserOrg"
            /></v-row>
            <span class="formInputLabel mt-0 mb-2">Users</span>
            <v-autocomplete
              ref="selectUser"
              multiple
              full-width
              name="autocomp"
              clearable
              :disabled="mailSyncUserOrg"
              label="Select users"
              solo
              v-if="usersList"
              flat
              :items="usersList"
              filled
              hide-selected
              height="52px"
              type
              append-icon="keyboard_arrow_down"
              background-color="#E5E5E5 !important"
              item-text="firstName"
              item-value="id"
              @update:search-input="searchUser"
              v-model="selectedUser"
              v-on:keyup.enter="actions(selectedUser, selectedUsers, 'ADD')"
              v-on:change="actions(selectedUser, selectedUsers, 'ADD')"
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{data.item.fullName}}</v-list-item-title>
                  <v-list-item-subtitle>{{data.item.email[0]}}</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
            <div class="list-container" v-if="selectedUsers.length > 0">
              <tag
                v-for="item in selectedUsers"
                :key="item.id"
                :text="item.firstName + ' ' + item.lastName"
                data-class="dynamicTagsdark"
                :showDelete="true"
                @click="() => actions(item, selectedUsers, 'DELETE')"
              ></tag>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="dialogProps.modalType === 'SYNC_CONFIRM'"></v-row>
      </template>
    </x-dialog>
    <x-table
      :columns="columns"
      :sortBy="sortBy"
      :updateTableSize="updateTableRowCount"
      :loading="tableLoading"
      :tableRows="mailSyncRequests"
      :paginationData="{
        pageSize,
        pageNumber,
        totalRecords,
        setPage: changePage,
      }"
    >
      <template slot="table-top-right">
        <v-row no-gutters justify="end">
          <x-button
            class="w-auto"
            color="#58e2c2"
            @click="requestSync"
            v-if="
              canRequestSync &&
              this.pageType === this.$enums.mailSyncPageType.org
            "
            buttonText="Request Synchronization" /></v-row
      ></template>
      <template slot="table_item" slot-scope="props"
        ><tr v-for="(mailSyncRequest, index) in props.tableRows" :key="index">
          <td v-if="pageType !== 'ORG'">{{ getOrgNameById(mailSyncRequest.orgId) }}</td>
          <td>
            {{ splitUnderscoreToCaptialise(mailSyncRequest.status) }}
          </td>
          <td>
            {{ getFormatedDateAsPerTimeZone(mailSyncRequest.requestedTime) }}
          </td>
          <td>
            <span v-if="mailSyncRequest.startedTime">
              {{ getFormatedDateAsPerTimeZone(mailSyncRequest.startedTime) }}
            </span>
            <span v-else>Not approved yet</span>
          </td>
          <td>
            <span v-if="mailSyncRequest.finishedTime">
              {{
                getFormatedDateAsPerTimeZone(mailSyncRequest.finishedTime)
              }}</span
            >
            <span v-else>Not finished yet</span>
          </td>
          <td>{{ mailSyncRequest.processed }} synchronized</td>
          <td>
            <x-button
              v-if="canApproveMailSync(mailSyncRequest)"
              color="#58e2c2"
              @click="() => approveSync(mailSyncRequest)"
              buttonText="Approve"
              class="ml-2"
            />
            <x-button
              color="#58e2c2"
              @click="() => routeToDetail(mailSyncRequest)"
              buttonText="View"
              class="ml-2"
            />
          </td>
        </tr>
      </template>
    </x-table>
  </div>
</template>
<script>
import ToggleButtonConfigurable from '@/components/Common/ToggleButtonConfigurable';
import MailSyncService from '@/services/MailSyncService';
import UserService from '@/services/UserService';
import { toSnakeCase, splitUnderscoreToCaptialise } from '../../helpers/common';
let debounce = require('lodash.debounce');
let debounceTimeInMilliseconds = 800;
export default {
  data() {
    return {
      pageSize: 20,
      pageNumber: parseInt(this.$route.params.pageNumber, 10) || 1,
      totalRecords: 0,
      splitUnderscoreToCaptialise,
      startedSearch: false,
      currentTabs: ['REQUESTED'],
      columns: [
        {
          label: 'Organization',
          field: 'orgName',
        },
        {
          label: 'Status',
        },
        {
          label: 'Requested',
          field: 'REQUESTED_TIME',
          sortable: true,
          sortOrder: 'ASC',
        },
        {
          label: 'Approved ',
          field: 'STARTED_TIME',
          sortable: true,
        },
        { label: 'Finished ', field: 'FINISHED_TIME', sortable: true },
        {
          label: 'Progress',
        },
        {
          label: 'Actions',
        },
      ],
      mailSyncUserOrg: true,
      sortByOptions: {
        sortBy: 'REQUESTED_TIME',
        sortOrder: 'ASC',
      },
      primaryButtonText: 'Submit',
      mailSyncRequests: [],
      userId: localStorage.getItem('userId'),
      dialogProps: {
        dialogTitle: 'Please Confirm',
        dialogState: false,
        modalType: '',
        showConfirm: true,
        rowSelected: {},
      },
      statues: [],
      tableLoading: true,
      mailSyncFilters: [
        { title: 'Requested', isSelected: false },
        { title: 'In Progress', isSelected: false },
        { title: 'Finished', isSelected: false },
      ],
      selectedUser: '',
      selectedUsers: [],
      allUsers: [],
    };
  },
  props: { pageType: String, title: String },
  methods: {
    /**
     * Load  mail sync requests that are displayed on the table
     * @param {Object} extras
     */
    async loadMailSyncRequests(extras) {
      this.tableLoading = true;
      this.mailSyncRequests = [];
      const params = {
        orgId:
          this.pageType === this.$enums.mailSyncPageType.systemAdmin
            ? undefined
            : this.currentlySelectedOrgId,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        sort: this.sortByOptions,
        status: ['REQUESTED'],
        ...extras,
      };
      const response = await MailSyncService.getMailSyncExecutions(params);
      const parsedResponse = this.parseResponse(response)[0];
      this.mailSyncRequests = parsedResponse.results;
      this.totalRecords = this.parseResponse(response)[0].total;
      this.tableLoading = false;
    },
    // Used for mail requestSync
    // this is use to toggle all user value in select users modal
    //
    toggleMailSyncUserOrg() {
      this.mailSyncUserOrg = !this.mailSyncUserOrg;
      this.selectedUsers = [];
    },
    /**
     * to change page of the table
     * @param {Number} pageNumber
     * @param {Boolean} onlyQuery
     */
    changePage(pageNumber, onlyQuery) {
      this.pageNumber = pageNumber;
      if (onlyQuery) {
        return this.$router.replace({
          path: 'p' + this.pageNumber,
          query: { active: this.currentTabs.join(',') },
        });
      }

      if (parseInt(this.$route.params.pageNumber, 10) !== this.pageNumber) {
        this.$router.push({
          path: 'p' + this.pageNumber,
          query: { active: this.currentTabs.join(',') },
        });
      }
    },
    /**
     * route to view the mail details
     * @param {Object} mailSyncRequest
     */
    routeToDetail(mailSyncRequest) {
      this.$router.push(`${mailSyncRequest.id}`);
    },

    // Request Synchronization
    async requestSync() {
      if (this.dialogProps.dialogState) {
        this.dialogProps.dialogTitle = 'Please Confirm';
        if (this.dialogProps.modalType === 'SYNC_CONFIRM') {
          this.dialogProps.dialogText = this.selectedUsers.length
            ? ''
            : 'No user selected. This will make a sync request for all users for current organization. Are you sure you want to proceed?';
          this.dialogProps.showConfirm = true;
          this.dialogProps.modalType = 'SYNC';
          return;
        }

        await MailSyncService.reuqestExecution({
          urlParams: {
            orgId:
              this.pageType === this.$enums.mailSyncPageType.systemAdmin
                ? this.orgId
                : this.currentOrgId,
          },
          params: this.selectedUsers.map((user) => user.id),
        });
        await this.loadMailSyncRequests({
          status: this.currentTabs,
        });
        this.dialogProps.dialogState = false;
        this.selectedUsers = [];
      } else {
        if (this.isOnboarded) {
          this.dialogProps.dialogTitle = 'Select User';
          this.dialogProps.showConfirm = false;
          this.dialogProps.modalType = 'SYNC_CONFIRM';
          this.dialogProps.dialogState = true;
        } else {
          this.snackbar('info', this.$message.ACTION_RESTRICTION_WHILE_ONBOARDING);
        }
      }
    },
    //  Close Dialog
    closeDialog() {
      this.dialogProps.dialogState = false;
      this.selectedUsers = [];
      this.selectUser = '';
      this.mailSyncUserOrg = true;
    },
    /**
     * updates the table row size
     * @param {Number} pageSize
     */
    updateTableRowCount(pageSize) {
      this.pageSize = pageSize;
      if (this.pageNumber !== 1) {
        return this.changePage(1);
      } else {
        this.loadMailSyncRequests({
          status: this.currentTabs,
        });
      }
    },
    /**
     * to add or remove user tags in modal
     * @param {Array} item
     * @param {Array} arr
     * @param {String} type
     */
    actions(item, arr, type) {
      this.$refs.selectUser.isMenuActive = false;
      if (!item.length && type === 'ADD') {
        return;
      }
      if (type === 'ADD') {
        const index = this.allUsers.findIndex((user) => user.id === item[0]);
        const userIndex = this.selectedUsers.findIndex(
          (user) => user.id === item[0]
        );
        if (userIndex === -1) {
          this.selectedUsers.push(this.allUsers[index]);
        }
        this.selectedUser = [];
      } else {
        const index = this.selectedUsers.findIndex(
          (user) => user.id === item.id
        );
        this.selectedUsers.splice(index, 1);
      }
    },
    /**
     * searches the user
     * @param {String} text
     */
    searchUser: debounce(function (text) {
      if (text !== null) {
        this.getUserList(text);
        this.startedSearch = !this.startedSearch;
      } else if (text === null && this.startedSearch) {
        this.getUserList('');
        this.startedSearch = !this.startedSearch;
      }
    }, debounceTimeInMilliseconds),
    /**
     * get all users list
     * @param {String} searchText
     */
    async getUserList(searchText = '') {
      const response = await UserService.loadUsersAll(
        false,
        this.pageType === this.$enums.mailSyncPageType.systemAdmin
          ? true
          : false,
        null,
        {
          pageNumber: 1,
          pageSize: 20,
          userStatuses: 'ACTIVE',
          sortBy: 'firstName',
          sortOrder: 'ASC',
          searchText,
        }
      );
      const paresedResponse = this.parseResponse(response);
      this.allUsers = paresedResponse[0].results;
    },
    /**
     * to get the selected filters for viewing mail sync requests
     * @param {Object} currentTab
     */
    async getSelectedTab(currentTab) {
      if (currentTab.status) {
        this.currentTabs.push(
          toSnakeCase(this.mailSyncFilters[currentTab.index].title)
        );
      } else {
        const index = this.currentTabs.findIndex(
          (item) =>
            item === toSnakeCase(this.mailSyncFilters[currentTab.index].title)
        );
        if (index !== -1) {
          this.currentTabs.splice(index, 1);
        }
      }
      this.changePage(1, true);
    },
    /**
     * sorting table data
     * @param {String} sort
     */
    sortBy(sort) {
      this.sortByOptions = sort;
      this.loadMailSyncRequests({ sort, status: this.currentTabs });
    },
    /**
     * to approve a sync report for a particular mailSyncId
     * @param {Object} mailSyncRequest
     */
    async approveSync(mailSyncRequest) {
      if (
        this.dialogProps.modalType !== 'APPROVE_CONFIRM' &&
        this.userId === String(mailSyncRequest.requestedBy).toLowerCase()
      ) {
        return this.snackbar(
          'error',
          'Reuqester cannot approve self mail sync'
        );
      }
      this.dialogProps.dialogTitle = 'Please Confirm';
      if (this.dialogProps.dialogState) {
        await MailSyncService.approveMail(this.dialogProps.rowSelected.id);
        await this.loadMailSyncRequests({
          status: this.currentTabs,
        });
        this.dialogProps.dialogState = false;
      } else {
        this.dialogProps.modalType = 'APPROVE_CONFIRM';
        this.dialogProps.dialogState = true;
        this.dialogProps.showConfirm = true;
        this.dialogProps.rowSelected = mailSyncRequest;
      }
    },
    // dialog by checking the modal type
    dialogAction() {
      if (
        this.dialogProps.modalType === 'SYNC' ||
        this.dialogProps.modalType === 'SYNC_CONFIRM'
      ) {
        this.requestSync();
      } else if (
        this.dialogProps.modalType === 'APPROVE' ||
        this.dialogProps.modalType === 'APPROVE_CONFIRM'
      ) {
        this.approveSync();
      }
    },
    /**
     * check whether request can be approve
     * @param {Object} mailSyncRequest
     */
    canApproveMailSync(mailSyncRequest) {
      return (
        this.pageType === this.$enums.mailSyncPageType.systemAdmin &&
        this.$can('approve', 'mailsync_request') &&
        mailSyncRequest.status === 'REQUESTED'
      );
    },
    //get mail sync filters from route
    getFiltersFromRoute() {
      if (this.$route.query.active) {
        const tabs = this.$route.query.active.split(',');
        this.currentTabs = [];
        tabs.forEach((activeTab) => {
          const isValid = this.mailSyncFilters.findIndex(
            (filter) => toSnakeCase(filter.title) === activeTab
          );

          if (isValid !== -1) {
            this.mailSyncFilters[isValid].isSelected = true;
            this.currentTabs.push(activeTab);
          }
        });
      } else {
        this.mailSyncFilters[0].isSelected = true;
      }
    },
  },
  created() {
    this.getFiltersFromRoute();
  },
  watch: {
    $route() {
      this.pageNumber =
        (this.$route.params && parseInt(this.$route.params.pageNumber, 10)) ||
        1;
      this.loadMailSyncRequests({
        status: this.currentTabs,
      });
    },
    currentOrgId: function () {
      // on the change of org it is setting the component to it's default values

      // setting isSelected for Requested tab
      this.mailSyncFilters[0].isSelected = true;
      this.mailSyncFilters[1].isSelected = false;
      // eslint-disable-next-line
      this.mailSyncFilters[2].isSelected = false;
      this.currentTabs = ['REQUESTED'];

      // Adding actions column
      // eslint-disable-next-line
      // this.columns[6] = { label: '' };

      // loading mail sync request for current Org
      this.loadMailSyncRequests({ status: this.currentTabs });

      // get the list of users for currentOrg
      this.getUserList();
    },
  },
  mounted() {
    if (this.pageType === 'ORG') {
      this.columns = this.columns.filter((column) => column.label !== 'Organization');
    }
    this.loadMailSyncRequests({
      status: this.currentTabs,
    });
    this.getUserList();
  },
  computed: {
    canRequestSync() {
      return this.isOwnOrgSelected()
        ? this.$can('request', 'mailsync')
        : this.$can('request', 'child_mailsync');
    },
    currentOrgId: {
      get() {
        return this.currentlySelectedOrgId;
      },
    },
    usersList() {
      let list = this.allUsers;
      this.selectedUsers.forEach((item) => {
        list = list.filter((vl) => {
          return vl.id !== item.id;
        });
      });
      return this.formatuserListForFullName(list);
    },
    isOnboarded: {
      get() {
        return this.onboardingStatus === 'ONBOARDED';
      }
    }
  },
  components: { ToggleButtonConfigurable },
};
</script>
